import { IInitialContextResult } from "../services/contextService";
import IPerson from "../interfaces/IPerson";


export const PersonMapper = {
    apiToDomain: (api: IInitialContextResult["henkilot"][0]): IPerson => {
        const fullname = api.etunimi + " " + api.sukunimi;
        return {
            id: api.id,
            name: api.nimi || fullname,
            image: api.kuva
        }
    },
};


export default PersonMapper

